// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type ResourceDetailAnalyticsQueryVariables = PrivateSchemaTypes.Exact<{
  filter: PrivateSchemaTypes.AnalyticsFilterWithGroups;
  topicId: PrivateSchemaTypes.Scalars['PositiveInt'];
  chartTimeUnit: PrivateSchemaTypes.TimeUnitEnum;
}>;


export type ResourceDetailAnalyticsQuery = (
  { __typename?: 'Query' }
  & { topic?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicModelAsEditor' }
    & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'deleted_at' | 'id' | 'currentTitle'>
    & { currentTopicVersion?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicVersionModel' }
      & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'topic_type'>
      & { elements: Array<(
        { __typename?: 'TopicElementModel' }
        & Pick<PrivateSchemaTypes.TopicElementModel, 'id'>
      )> }
    )> }
  ) | (
    { __typename?: 'TopicModelAsMember' }
    & Pick<PrivateSchemaTypes.TopicModelAsMember, 'deleted_at' | 'id' | 'currentTitle'>
    & { currentTopicVersion?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicVersionModel' }
      & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'topic_type'>
      & { elements: Array<(
        { __typename?: 'TopicElementModel' }
        & Pick<PrivateSchemaTypes.TopicElementModel, 'id'>
      )> }
    )> }
  )>, analytics: (
    { __typename?: 'AnalyticsModel' }
    & { resources: (
      { __typename?: 'AnalyticsResourcesModel' }
      & Pick<PrivateSchemaTypes.AnalyticsResourcesModel, 'averageRating' | 'usersViewedResourceCount' | 'totalViewsCount' | 'resourceActivityOverviewCount'>
      & { totalViewsCountMobile: PrivateSchemaTypes.AnalyticsResourcesModel['totalViewsCount'] }
      & { ratingSpread: Array<(
        { __typename?: 'AnalyticsRatingSpreadModel' }
        & Pick<PrivateSchemaTypes.AnalyticsRatingSpreadModel, 'rating' | 'count'>
      )>, topicViewsByTimeUnit: Array<(
        { __typename?: 'AnalyticsHitCountByTimeUnit' }
        & Pick<PrivateSchemaTypes.AnalyticsHitCountByTimeUnit, 'count' | 'day'>
      )> }
    ), workbooks: (
      { __typename?: 'AnalyticsWorkbooksModel' }
      & Pick<PrivateSchemaTypes.AnalyticsWorkbooksModel, 'workbooksCount' | 'completedCount' | 'passedWorkbooksInPercents'>
    ) }
  ) }
);


export const ResourceDetailAnalyticsDocument = gql`
    query ResourceDetailAnalytics($filter: AnalyticsFilterWithGroups!, $topicId: PositiveInt!, $chartTimeUnit: TimeUnitEnum!) {
  topic(id: $topicId) {
    deleted_at
    id
    currentTitle
    currentTopicVersion {
      id
      elements(filters: {name: quizzes}) {
        id
      }
      topic_type
    }
  }
  analytics(filter: $filter) {
    resources {
      ratingSpread {
        rating
        count
      }
      averageRating
      usersViewedResourceCount
      totalViewsCount
      totalViewsCountMobile: totalViewsCount(deviceType: MOBILE)
      topicViewsByTimeUnit(unit: $chartTimeUnit) {
        count
        day
      }
      resourceActivityOverviewCount(overviewFilter: {resourceId: $topicId})
    }
    workbooks {
      workbooksCount
      completedCount
      passedWorkbooksInPercents
    }
  }
}
    `;

/**
 * __useResourceDetailAnalyticsQuery__
 *
 * To run a query within a React component, call `useResourceDetailAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceDetailAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceDetailAnalyticsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      topicId: // value for 'topicId'
 *      chartTimeUnit: // value for 'chartTimeUnit'
 *   },
 * });
 */
export function useResourceDetailAnalyticsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ResourceDetailAnalyticsQuery, ResourceDetailAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ResourceDetailAnalyticsQuery, ResourceDetailAnalyticsQueryVariables>(ResourceDetailAnalyticsDocument, options);
      }
export function useResourceDetailAnalyticsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ResourceDetailAnalyticsQuery, ResourceDetailAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ResourceDetailAnalyticsQuery, ResourceDetailAnalyticsQueryVariables>(ResourceDetailAnalyticsDocument, options);
        }
export type ResourceDetailAnalyticsQueryHookResult = ReturnType<typeof useResourceDetailAnalyticsQuery>;
export type ResourceDetailAnalyticsLazyQueryHookResult = ReturnType<typeof useResourceDetailAnalyticsLazyQuery>;
export type ResourceDetailAnalyticsQueryResult = Apollo.QueryResult<ResourceDetailAnalyticsQuery, ResourceDetailAnalyticsQueryVariables>;